import logoGris from '../../img/logoGris.png';
import './style.css';
import imgJBL from '../../img/inicio/jbl.jpg';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import logoDegradadoAmarillo from '../../img/logoDegradadoAmarillo.png';
import logoVbrassQuintaSeccion from '../../img/vbrassLogoCuartaSeccion.png';
import fbAmarillo from '../../img/fbAmarillo.png';
import igAmarillo from '../../img/igAmarillo.png';
import lkdAmarillo from '../../img/lkdAmarillo.png';
import { Carousel } from 'react-bootstrap';
import { useRef } from 'react';

function Proyecto() {
    const history = useHistory();

    const handleClick = () => {
        history.push('/'); // cambia a la ruta deseada
    };


    // 1. Crear la referencia para acceder a los métodos del Carousel
    const carouselRef = useRef(null);

    // Funciones para manejar la navegación
    const handlePrev = () => {
        if (carouselRef.current) {
            carouselRef.current.prev();
        }
    };

    const handleNext = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
    };

    return (  
        <div className='proyecto'>
            <div className="row primeraSeccion m-0 bg-dark">
                <div className="row rowLogo">
                    <div className="col-4 col-sm-3 col-md-2 col-lg-1 m-0 p-0 d-flex">
                        <img src={logoGris} alt="" width={'70%'} className='mb-0 mt-auto' onClick={handleClick} style={{ cursor: 'pointer' }}/>
                    </div>
                </div>
                <div className="col-12 mb-5 p-0">
                    <div className="row content my-5">
                        <div className="col-xl-5 d-flex align-items-center">
                            <div className="row m-0 p-0">
                                <div className="col-xl-11">
                                    <h3>Lorem ipsum</h3>
                                </div>
                                <div className="col-xl-11 mt-3">
                                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam</p>
                                </div>
                                <div className="col-xl-11 mt-3 d-flex">
                                    <Link className='btn' to={'/contacto'}>Cotiza tu proyecto</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-7 h-100 p-0 d-none d-xl-flex justify-content-center align-items-center">
                            <div className='w-100 contenedorIMG'>
                                <img src={imgJBL} alt="" className='imgJBL'/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row segundaSeccion m-0 py-5">
                <div className="col-md-6 ps-md-0 pe-md-5">
                    <img src={imgJBL} alt="" />
                </div>
                <div className="col-md-6 pe-md-0 ps-md-5 pt-5 pt-md-0">
                    <img src={imgJBL} alt="" />
                </div>
                <div className="col-md-12 pt-md-5 px-md-5 pt-5 pt-md-0">
                    <img src={imgJBL} alt="" />
                </div>
            </div>
            <div className="row terceraSeccion my-5">
                <div className="col-xl-5 my-xl-5 py-xl-4">
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur</p>
                </div>
                <div className="col-xl-2 my-xl-5 py-xl-4"></div>
                <div className="col-xl-5 mt-5 my-xl-5 py-xl-4">
                    <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur</p>
                </div>
            </div>
            <div className="row cuartaSeccion m-0 py-5"> 
                <div className="col-12 d-flex flex-column align-items-center">
                    
                    {/* 2. Referencia y Controles Desactivados */}
                    <Carousel 
                        ref={carouselRef} 
                        indicators={false} 
                        controls={false} // <--- Desactiva las flechas predeterminadas
                        className="custom-product-carousel d-none d-lg-block" // Clase para aplicar CSS
                    >
                        <Carousel.Item>
                            {/* El contenido de las tres imágenes */}
                            <div className="carouselItemContent">
                                <div className="row m-0 pt-5 d-flex justify-content-center">
                                    {/* Asegúrate de que las columnas están diseñadas para la tarjeta */}
                                    <div className="col-4 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                    <div className="col-4 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                    <div className="col-4 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>
                        <Carousel.Item>
                            {/* El contenido de las tres imágenes */}
                            <div className="carouselItemContent">
                                <div className="row m-0 pt-5 d-flex justify-content-center">
                                    {/* Asegúrate de que las columnas están diseñadas para la tarjeta */}
                                    <div className="col-4 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                    <div className="col-4 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                    <div className="col-4 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>
                        {/* Añade más Carousel.Item si quieres que el carrusel se mueva */}
                    </Carousel>
                    <Carousel 
                        ref={carouselRef} 
                        indicators={false} 
                        controls={false} // <--- Desactiva las flechas predeterminadas
                        className="custom-product-carousel d-lg-none" // Clase para aplicar CSS
                    >
                        <Carousel.Item>
                            {/* El contenido de las tres imágenes */}
                            <div className="carouselItemContent">
                                <div className="row m-0 pt-5 d-flex justify-content-center">
                                    {/* Asegúrate de que las columnas están diseñadas para la tarjeta */}
                                    <div className="col-12 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>                        
                        <Carousel.Item>
                            {/* El contenido de las tres imágenes */}
                            <div className="carouselItemContent">
                                <div className="row m-0 pt-5 d-flex justify-content-center">
                                    {/* Asegúrate de que las columnas están diseñadas para la tarjeta */}
                                    <div className="col-12 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>                        
                        <Carousel.Item>
                            {/* El contenido de las tres imágenes */}
                            <div className="carouselItemContent">
                                <div className="row m-0 pt-5 d-flex justify-content-center">
                                    {/* Asegúrate de que las columnas están diseñadas para la tarjeta */}
                                    <div className="col-12 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>                        
                        <Carousel.Item>
                            {/* El contenido de las tres imágenes */}
                            <div className="carouselItemContent">
                                <div className="row m-0 pt-5 d-flex justify-content-center">
                                    {/* Asegúrate de que las columnas están diseñadas para la tarjeta */}
                                    <div className="col-12 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>                        
                        <Carousel.Item>
                            {/* El contenido de las tres imágenes */}
                            <div className="carouselItemContent">
                                <div className="row m-0 pt-5 d-flex justify-content-center">
                                    {/* Asegúrate de que las columnas están diseñadas para la tarjeta */}
                                    <div className="col-12 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>                        
                        <Carousel.Item>
                            {/* El contenido de las tres imágenes */}
                            <div className="carouselItemContent">
                                <div className="row m-0 pt-5 d-flex justify-content-center">
                                    {/* Asegúrate de que las columnas están diseñadas para la tarjeta */}
                                    <div className="col-12 px-4 py-5 d-flex justify-content-center">
                                        <img src={imgJBL} alt="Altavoz JBL" className="img-fluid custom-card-image" />
                                    </div>
                                </div>
                            </div>
                        </Carousel.Item>                        
                        {/* Añade más Carousel.Item si quieres que el carrusel se mueva */}
                    </Carousel>
                    {/* 3. NUEVOS CONTROLES: Alineados con el texto y más separados de las imágenes */}
                    <div className="controles d-flex pb-5 justify-content-between align-items-center mt-5">
                        <button className="custom-arrow-btn" onClick={handlePrev}>
                            <i className="bi bi-arrow-left"></i>
                        </button>
                        
                        <span className="lorem-ipsum-text mx-4">
                            Lorem ipsum
                        </span>

                        <button className="custom-arrow-btn" onClick={handleNext}>
                            <i className="bi bi-arrow-right"></i>
                        </button>
                    </div>

                </div>
            </div>
            <div className="row quintaSeccion m-0 d-flex align-items-center justify-content-center">
                <img src={logoDegradadoAmarillo} alt="" className='logoDegradadoAmarillo'/>
                <div className='content'>
                    <div className="row m-0">
                        <div className="col-xl-7 mt-5 m-sm-0 d-flex">
                            <img src={logoVbrassQuintaSeccion} alt="" className='logoVbrass'/>
                        </div>
                    </div>
                    <div className="row m-0 mt-5">
                        <div className="col-xl-6">
                            <h3>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et</h3>
                        </div>
                    </div>
                    <div className="row m-0 mt-5">
                        <div className="col-xl-4">
                            <Link className='btnCotiza' to={'/contacto'}>Cotiza tu proyecto</Link>
                        </div>
                    </div>
                    <div className="row m-0 mt-5">
                        <div className="col-xl-5 col-xxl-4 containerRedesSociales">
                            <a href="https://www.instagram.com/vbrass_studio" target="_blank" rel="noopener noreferrer" className='btnRedSocial'>
                                <img src={fbAmarillo} alt="" className='iconoRedSocial'/>
                            </a>
                            <a href="https://www.instagram.com/vbrass_studio" target="_blank" rel="noopener noreferrer" className='btnRedSocial'>
                                <img src={lkdAmarillo} alt="" className='iconoRedSocial'/>
                            </a>
                            <a href="https://www.instagram.com/vbrass_studio" target="_blank" rel="noopener noreferrer" className='btnRedSocial'>
                                <img src={igAmarillo} alt="" className='iconoRedSocial'/>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Proyecto;